<script setup lang="ts">
import { computed } from "vue"
import SubscriptionGemIcon from "./SubscriptionGemIcon.vue"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "~/components/ui/tooltip"
import { subscriptionBadgeTier } from "~/lib/subscriptions/features"
import { useGroupsStore } from "~/stores/groups"
import type { Subscription } from "~/types/user"
import { cn } from "~/lib/utils"

// The subscriber badge next to a name (chat, member lists, profile, friends) - shown only when the
// user's subscription includes the badge feature. Pass `subscription` when the user object carries
// one; with only `userId` (friends), it is looked up in the cached group rosters, and nothing is
// shown for a user none of them knows.
// Brings its own TooltipProvider: it also renders outside the layouts that supply one (the
// profile dialog is mounted in app.vue), where a bare Tooltip throws on the missing injection.

const props = defineProps<{
  subscription?: Subscription | null
  userId?: string
  class?: string
}>()

const groupsStore = useGroupsStore()

const tier = computed(() => {
  const subscription = props.subscription ?? (props.userId ? groupsStore.getKnownUserSubscription(props.userId) : null)
  return subscriptionBadgeTier(subscription)
})
</script>

<template>
  <TooltipProvider v-if="tier" :delay-duration="200">
  <Tooltip>
    <TooltipTrigger as-child>
      <span
          :class="cn('inline-flex shrink-0 items-center', props.class)"
          role="img"
          :aria-label="`Подписка ${tier}`"
      >
        <SubscriptionGemIcon class="size-full" />
      </span>
    </TooltipTrigger>
    <TooltipContent>Подписка {{ tier }}</TooltipContent>
  </Tooltip>
  </TooltipProvider>
</template>
